import { getAdFormatQueryOptions } from "../../queries/adFormats";

// adFormat is pre-fetched when a user hover a 'view adFormat' link
export const adFormatViewLoader = ({ params, context: { queryClient } }) => {
  const { adFormatId } = params;
  queryClient.ensureQueryData(getAdFormatQueryOptions(adFormatId, queryClient));
};
